/* src/app/modules/patternmatch/components/pm-table/pm-table.component.scss */
:host {
  --solution-bg-color: var(--highlight-10);
  --solution-bg-color-highlight: var(--highlight-15);
  --border-color_: var(--border-color, var(--highlight-20));
  --border-thickness_: var(--border-thickness, 1px);
  --bar-color-01-light_: var(--bar-color-01-light, rgba(61, 195, 176, 0.15));
  font: var(--body-1);
}
sh-text {
  cursor: pointer;
  width: initial;
  -webkit-user-select: none;
  user-select: none;
  display: flex;
  flex-direction: row;
  align-items: center;
}
sh-text sh-icon {
  transition: var(--transition-time) all ease-in-out;
  opacity: 0.5;
}
sh-text .hidden {
  opacity: 0;
}
.pattern-description {
  text-overflow: ellipsis;
  line-break: anywhere;
}
.table {
  display: grid;
  overflow-x: hidden;
  grid-template-columns: 1fr 7fr 7fr;
}
.table > * {
  cursor: pointer;
  transition: var(--transition-time) all ease-in-out;
  padding: 1rem;
  border-top: var(--border-thickness_) solid var(--border-color_);
}
.table > sh-text {
  border-top: 0px;
}
.table .item {
  transition: var(--transition-time) opacity ease-in-out;
  cursor: pointer;
  position: relative;
  opacity: 1;
}
.table .item:hover::before {
  background-color: var(--highlight-5);
  pointer-events: none;
  content: "";
  position: absolute;
  left: -1000%;
  right: -1000%;
  top: 0px;
  bottom: 0px;
}
.type {
  text-decoration: underline;
}
.highlighted {
  background-color: var(--bar-color-01-light_);
}
.clickable {
  cursor: pointer;
}
.solutions {
  display: flex;
  justify-items: start;
  align-items: flex-start;
  flex-direction: row;
  gap: 0.5rem;
}
.solution {
  background: var(--solution-bg-color);
  border-radius: 1rem;
  padding: 0.25rem;
  padding-left: 1rem;
  padding-right: 1rem;
  display: flex;
  white-space: nowrap;
  align-items: center;
  color: initial;
  text-decoration: underline;
}
.solution:hover {
  background: var(--solution-bg-color-highlight);
}
.table .disabled,
.disabled {
  opacity: 0.5;
}
.span-2 {
  grid-column-start: 1;
  grid-column-end: 3;
}
.mobile-solutions-header {
  margin-top: 0.5rem;
}
.mobile-solutions {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;
}
.mobile-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.mobile-item {
  transition: var(--transition-time) all ease-in-out;
  box-shadow: var(--shadow-raised);
  padding: 1rem;
  display: grid;
  gap: 0.5rem;
  grid-template-columns: 1fr 4fr;
}
.modal-text {
  white-space: pre-line;
  line-height: 1.6;
}
/*# sourceMappingURL=pm-table.component.css.map */
